import apiKit from "./apiKit";

export const getOffers = async (body) => {
  try {
    const url = `prices/get_local_utility_price/?zipcode=${body.postalCode}&consumption=${body.energyConsumption}&street=${body.street}&city=${body.city}`;
    const res = await apiKit.get(url);
    return res.data;
  } catch (e) {
    return e.response ? e.response.data : e;
  }
};

export const getPrices = async (body) => {
  try {
    const url = `prices/get_co2_savings?consumption=${body?.energyConsumption}&year=2025`;
    const res = await apiKit.get(url);
    return res.data;
  } catch (e) {
    return e.response ? e.response.data : e;
  }
};

export const getInformation = async () => {
  try {
    const url = `prices/epex_day_ahead?from=2015-04-03T00:00:00Z&to=2025-05-05T00:00:00Z`;
    const res = await apiKit.get(url);
    return res.data;
  } catch (e) {
    return e.response ? e.response.data : e;
  }
};

export const offerCalculator = async (body) => {
  try {
    let id = null;

    const storedId = await localStorage.getItem("customer_id");
    if (storedId && storedId !== "null" && storedId !== "undefined") {
      id = storedId;
    }

    let url = `offer_calculator?tariff_name=${body.tariffName}&consumption=${body.consumption}&zip_code=${body.zipCode}&hasSmartMeter=${body.hasSmartMeter}`;
    if (body.privacy) url += `&privacy=${body.privacy}`;
    if (body.customerType) url += `&customerType=${body.customerType}`;
    if (id) {
      url += `&id=${id}`;
    }
    if (body.householdSize) url += `&householdSize=${body.householdSize}`;
    if (body.street) url += `&street=${body.street}`;
    if (body.email) url += `&email=${body.email}`;
    const res = await apiKit.get(url);
    return res.data;
  } catch (e) {
    return e.response ? e.response.data : e;
  }
};

export const getAddress = async (body) => {
  try {
    const url = `address/getAddress`;
    const res = await apiKit.post(url, body);
    return res.data;
  } catch (e) {
    return e.response ? e.response.data : e;
  }
};

export const validateCusomerId = async (body) => {
  try {
    const url = `customer/getConsumer/?saas_customer_lead_id=${body?.saas_customer_lead_id}`;
    const res = await apiKit.get(url);
    return res.data;
  } catch (e) {
    return e.response ? e.response.data : e;
  }
};
